// extracted by mini-css-extract-plugin
export default {"rewardsList":"RewardsList_rewardsList__cI0Er"};